import { render } from "./SurveyLayout.vue?vue&type=template&id=56034b01&scoped=true"
import script from "./SurveyLayout.vue?vue&type=script&lang=js"
export * from "./SurveyLayout.vue?vue&type=script&lang=js"

import "./SurveyLayout.vue?vue&type=style&index=0&id=56034b01&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/epr-survey-builder/Vue_Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56034b01"]])

export default __exports__